import { render, staticRenderFns } from "./PFSettlementConsentSettings.vue?vue&type=template&id=05cbf9de"
import script from "./PFSettlementConsentSettings.vue?vue&type=script&lang=js"
export * from "./PFSettlementConsentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports